import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
  } from "@mui/material";
   import { EnumItemModel, } from "../../../api/api";
   import EnumItemRow from "./EnumItemRow";
   import AddEnumItemRow from "./AddEnumItemRow";

  
  interface Props {
    enumName: string;
    items: EnumItemModel[];
    onAddEnumItem: (itemName: string) => Promise<void> | void;
  }
  
  const columnWidths = {
    value: "50%",
    name: "50%"
  };

  const PropertyTable: React.FC<Props> = ({items, onAddEnumItem }) => {
    return items != null ? (
      <TableContainer component={Paper} sx={{ mt: 1, width: "100%" }}>
        <Table size="small" sx={{ tableLayout: "fixed", minWidth: 800 }}>
          <TableHead>
            <TableRow>
            <TableCell sx={{ width: columnWidths.name }}><strong>Name</strong></TableCell>
            <TableCell sx={{ width: columnWidths.value }}><strong>Value</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((i, idx) => (
              <EnumItemRow key={idx} item={i} />
            ))}
            <AddEnumItemRow onSave={onAddEnumItem} />
          </TableBody>
        </Table>
      </TableContainer>
    ) : (
      <Typography variant="body2" sx={{ pl: 2, mt: 1 }}>
        No properties defined.
      </Typography>
    );
  };
  
  export default PropertyTable;
